export default "__VITE_ASSET__BfaSOrQf__"